/**
 * @type {<T extends (...args: any)=>any>(fn: T) => (...args: Parameters<T>)=> false|ReturnType<T>}}
 */
export default function onlyVisibleRun(fn) {
  return function (...args) {
    if (document.visibilityState === "visible") {
      return fn.apply(this, args);
    }
    return false;
  };
}
